export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-10-06T13:43:20",
  lastPipeline: "6710",
  version: "0.0.0",
  sentryDsn: '',
};
